// css =>
import "../../BaseStructure.css";
import Styled from "./products.module.css";

// componenets =>
import Menu from "../../components/menu/menu.comp";
import SpinnerBar from "../../components/spinner-bar/spinner.comp";
import ProductBox from "../../components/product-box/product-box.comp";
import PagePagination from "../../components/page-pagination/page-pagination.comp";
import CategoryFilterMenu from "../../components/category-filter-menu/category-filter-menu.comp";
import CategoryFilterSubMenu from "../../components/category-filter-sub-menu/category-filter-sub-menu.comp";

// pictures =>
import Pic1 from "../../assets/pictures/pro-pic1.jpg";
import Pic2 from "../../assets/pictures/pro-pic2.jpg";
import Pic3 from "../../assets/pictures/pro-pic3.jpg";
import Pic4 from "../../assets/pictures/pro-pic4.jpg";

// react =>
import { useEffect, useState, useRef } from "react";

// services =>
import { getCategoryList, getProductList } from "./products-service";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';
import { getTranslatedField } from '../../utils/get-translated-field';

// context =>
import { useTheme } from '../../context/theme-context';

function Products () {
    const filterSubMenuRef = useRef(null);

    const { language } = useLanguage();
    const t = (key) => getTranslation(language, key);

    const [isLoading, setIsLoading] = useState(false);
    const [isFilteringSubMenuOpen, setIsFilteringSubMenuOpen] = useState(false);

    const [productList, setProductList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    const [filterUrl, setFilterUrl] = useState("");
    const [categoryUrl, setCategoryUrl] = useState("");

    const pageSize = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfProducts, setNumberOfProducts] = useState(0);

    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (
                isFilteringSubMenuOpen &&
                filterSubMenuRef.current &&
                !filterSubMenuRef.current.contains(event.target)
            ) {
                setIsFilteringSubMenuOpen(false);
            }
        };

        document.addEventListener("pointerdown", handleClickOutside);

        return () => {
            document.removeEventListener("pointerdown", handleClickOutside);
        };
    }, [isFilteringSubMenuOpen]);

    useEffect(() => {
        document.title = 'برگ سبز | نمایش محصولات';

        const fetchProducts = async () => {
            setIsLoading(true);
            const [categorys, products] = await Promise.all([

                getCategoryList(),
                getProductList(currentPage, filterUrl, categoryUrl),
            ]);

            setCategoryList(categorys);
            setProductList(products.results);
            setNumberOfProducts(products.count);

            setIsLoading(false);
        };

        fetchProducts();
    }, [filterUrl, categoryUrl, currentPage]);

    const handleOpenFilteringSubMenu = () => {
        if (isFilteringSubMenuOpen) {
            setIsFilteringSubMenuOpen(false);
        } else {
            setIsFilteringSubMenuOpen(true);
        }
    }

    const handleFilterChange = (filter) => {
        setFilterUrl(filter);
        setIsFilteringSubMenuOpen(false);
    }

    const handleCategoryFilterChange = (categoryId) => {
        setCategoryUrl(categoryId);
        setIsFilteringSubMenuOpen(false);
    }

    return (
        <>
            <header>
                <Menu />

                <div ref={ filterSubMenuRef }>
                    <CategoryFilterMenu mainTitle={ t('filterAndCategoryMenuOption2') } subMenuTitle={ t('filterAndCategoryMenuOption3') } numberOfItems={`${ numberOfProducts } ${ t('filterAndCategoryMenuOption1') }`} onClick={ handleOpenFilteringSubMenu } />
                    <CategoryFilterSubMenu
                        haveFilterBox={ true }
                        categorys={ categoryList }
                        isOpen={ isFilteringSubMenuOpen }
                        handleFilterChange={ handleFilterChange }
                        handleCategoryFilterChange={ handleCategoryFilterChange }
                        cloesWithBackdrop={() => {
                            setIsFilteringSubMenuOpen(false);
                        }}
                    />
                </div>

                <div className="row">
                    <div className="col-12">
                        <p
                            className={ Styled.products_info_text }
                            style={{
                                color: theme === "day" ? "#474D3D" : ""
                            }}
                        >Discover Beautiful Plants To Every Space</p>
                    </div>
                </div>
            </header>

            {
                isLoading ? (
                    <SpinnerBar />
                ) : (
                    <>
                        <main>
                            <div className={`row ${ Styled.products_box } `}>
                                {
                                    productList && productList.length > 0 ? (
                                        productList.map((product) => {
                                            return <ProductBox
                                                index={ product.id }
                                                productName={ getTranslatedField(product, 'name', language) }
                                                productPicture={ product.thumbnail_url }
                                            />
                                        })
                                    ) : (
                                        <p
                                            style={{
                                                color: theme === "day" ? "#000000" : ""
                                            }}
                                        >هیچ محصولی ثبت نشده است!</p>
                                    )
                                }
                            </div>
                            
                            <br />
                        </main>

                        <fotter >
                            <div className={`row ${ Styled.page_pagination_frame }`}>
                                <PagePagination
                                    currentPage={ currentPage }
                                    totalCount={ numberOfProducts }
                                    pageSize={ pageSize }
                                    onPageChange={(page) => setCurrentPage(page)}
                                />
                            </div>
                        </fotter>
                    </>
                )
            }
        </>
    );
}

export default Products;
